import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initGetStartedRed() {
  const parent = document.querySelector('.get-started-red');
  if (!parent) return;

  const inner = parent.querySelector('.get-started-red__bg');

  const animation = new ParticleWaveBackground(inner, {
    autoStart: false,
    planeWidth: 13.699,
    planeHeight: 5.282,
    widthSegments: 120,
    heightSegments: 70,
    particleSize: 0.03,
    waveHeight: 0.5,
    noiseScale: 2,
    animationSpeed: 6000,
    fadePower: 2,
    color: [1, 1, 1],
    bgColor: [1, 0.18, 0],
    rotationX: -0.797964534011807,
    rotationY: 0.282743338823081,
    rotationZ: -0.100530964914873,
    cameraPosition: [-4.26, -0.58, 5],
    cameraRotationX: 0,
    cameraRotationY: 0,
    cameraRotationZ: 0,
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });
}
